import { render, staticRenderFns } from "./ProtocolForm.vue?vue&type=template&id=083851d1&scoped=true"
import script from "./ProtocolForm.vue?vue&type=script&lang=js"
export * from "./ProtocolForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083851d1",
  null
  
)

export default component.exports